import React, { Component } from 'react';
import SurveyRect from './Shared/SurveyRect';
import FormatText from '../Utils/TextFormatter';
import Button from './Shared/Button';

export default class NumberQuestionPage extends Component {

    state = {
        value:50,
    }

    componentDidMount(){
        this.setState({value: this.props.initValue});
    }


    render(){
        const {style, question, minValue, maxValue, unit, qTextSize, altButtonTitle} = this.props;
        const padding = 28;
        const thumbSize = 32;

        let questionText;
        if(qTextSize === `small`){ 
            questionText = <div className="smallQuestion">{FormatText(global.isMale,question)}</div>
        }
        if(qTextSize === `medium`){ 
            questionText = <h3>{FormatText(global.isMale,question)}</h3>
        }
        if(qTextSize === `large`){ 
            questionText = <h2>{FormatText(global.isMale,question)}</h2>
        }

        const buttonText = (altButtonTitle !== "" && altButtonTitle !== undefined) ? altButtonTitle : "המשך";

        return <div style={style}>
            <SurveyRect {...this.props} H={440}>
                <div  style={{
                    position: "absolute",
                    right: padding,
                    left: padding,
                    top: padding,
                    bottom: 0,
                    overflow: "scrollY",
                    textAlign: "right",
                }}>
        
                    {questionText}
                    <span style={{fontSize:8, lineHeight: 4}}>▒▒▒▒▒▒▒▒▒▒▒▒</span>
                    <div style={{
                        position: "absolute",
                        right: 0,
                        left: 0,
                        bottom: 120,
                        // textAlign: "center",
                    }}>
                        <span style={{
                            direction: 'ltr',
                            display: 'inline-block',
                            fontFamily: "monospace", 
                            fontSize: 50,
                            fontWeight: 700,
                            lineHeight: 1.8,
                        }}>{this.state.value}</span>
                        <span style={{fontSize: 24}}> {unit}</span>
                        <input type="range" 
                            className={(global.browser === "ie" || global.browser === "edge") ? "ms_slider" : "slider"}
                            min={minValue} 
                            max={maxValue} 
                            value={this.state.value} 
                            step={1} 
                            onChange={ e=>{
                                this.setState({value:e.target.value});
                            }}
                        />
                        <div
                            key="sliderThumb"
                            style={{ 
                            position: 'relative', 
                            marginTop: -thumbSize + thumbSize*0.5 - 6,
                            width:thumbSize, 
                            height: thumbSize,
                            borderRadius: '100%',
                            pointerEvents: 'none', 
                            backgroundColor: global.colorTheme.main, 
                            // opacity: 0.5,
                            transform: `translateX(-${(style.width-padding*2-thumbSize-24)*(this.state.value-minValue)/(maxValue-minValue)+2}px)`
                            }} />
                    </div>
                    <Button style={{
                        position:"absolute",
                        left:0,
                        bottom:padding,
                    }} text={buttonText} isActive={true} onClick={() => {
                        // validate & save
                        this.SetAnswer();
                    }}/>
                </div>
            </SurveyRect>
        </div>
    }

    SetAnswer()
    {
        global.setAnswer(this.props.qKey, this.state.value);
        global.nextStage(this.props.followingScreen);
    }
}


// WEBPACK FOOTER //
// ./src/Comp/NumberQuestionPage.js